import { LOGOUT_URL } from '@src/global/login';

export const logOut = (returnTo) => {
    const retUrl = returnTo ? returnTo : LOGOUT_URL;
    window.localStorage.removeItem('jwt');
    window.localStorage.removeItem('user_info');
    window.location.replace(retUrl);
};
